import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { eTypeResult } from 'src/app/models/common/enumModel';
import { IDeshabilitarAccesosBatchModel } from 'src/app/models/interfaces/accesos/IDeshabilitarAccesosBatchModel';
import { AccesoPersonaService } from 'src/app/services/acceso-personal/acceso-persona.service';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';

@Component({
  selector: 'app-reestablecer-accesos-personal-dialog',
  templateUrl: './reestablecer-accesos-personal-dialog.component.html',
  styleUrls: ['./reestablecer-accesos-personal-dialog.component.scss']
})
export class ReestablecerAccesosPersonalDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ReestablecerAccesosPersonalDialogComponent>,
    private accesoPersonalService: AccesoPersonaService,
    private alertDialogService: AlertDialogService,
    @Inject(MAT_DIALOG_DATA) public model: IDeshabilitarAccesosBatchModel) { }

  ngOnInit() {
  }

  Save(): void {
    this.accesoPersonalService.reestablecer(this.model).subscribe(result => {
      if(result.type!=eTypeResult.SUCCESS){
        this.alertDialogService.open(result.message);
      }    
      else{  
        this.dialogRef.close(true);
        this.alertDialogService.open('Se restablecieron los accesos de las personas seleccionadas.');
      }
    });    
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
  esValido(): boolean {
    if (this.model.comentarios == "")
      return true;
    else
      return false;
  }

}
